// frontend/src/services/games/achievementBus.ts

import { AchievementDefinition } from '../../config/achievements';

type Listener = (achievements: AchievementDefinition[]) => void;

const listeners = new Set<Listener>();

export function subscribeAchievementUnlocks(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function publishAchievementUnlocks(achievements: AchievementDefinition[]): void {
  if (achievements.length === 0) return;
  listeners.forEach((listener) => listener(achievements));
}
